import React from 'react';
import Icon from '../../../components/AppIcon';

const TimingFlexibility = ({ selectedTiming, onTimingSelect }) => {
  const timingOptions = [
    {
      id: 'now',
      label: 'Right Now',
      icon: 'Clock',
      description: 'Available immediately'
    },
    {
      id: 'today',
      label: 'Today',
      icon: 'Calendar',
      description: 'Sometime today'
    },
    {
      id: 'this-week',
      label: 'This Week',
      icon: 'CalendarDays',
      description: 'Within the next 7 days'
    },
    {
      id: 'flexible',
      label: 'Flexible',
      icon: 'CalendarRange',
      description: 'No specific timeframe'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-heading font-semibold text-foreground">
        Timing Preference
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {timingOptions?.map((timing) => (
          <button
            key={timing?.id}
            onClick={() => onTimingSelect(timing?.id)}
            className={`
              flex items-center space-x-3 p-3 rounded-md border-2
              transition-therapeutic text-left
              ${selectedTiming === timing?.id
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/30'
              }
            `}
          >
            <div className={`
              flex items-center justify-center w-10 h-10 rounded-md flex-shrink-0
              ${selectedTiming === timing?.id ? 'bg-primary/10' : 'bg-muted'}
            `}>
              <Icon 
                name={timing?.icon} 
                size={20} 
                color={selectedTiming === timing?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center space-x-2 mb-0.5">
                <span className="text-sm font-medium text-foreground">
                  {timing?.label}
                </span>
                {selectedTiming === timing?.id && (
                  <Icon name="Check" size={14} color="var(--color-primary)" />
                )}
              </div>
              <p className="text-xs text-muted-foreground">
                {timing?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimingFlexibility;